import { apiRequest, API_BASE_URL } from './api.config';
import { ApiResponse } from '@utilities/types';

export interface ContrastColorOption {
    id: string;
    name: string;
    image: string;
}

export async function getContrastColorCatalog(): Promise<ContrastColorOption[]> {
    const res = await apiRequest<ApiResponse<{ options: ContrastColorOption[] }>>('/contrast-colors/catalog', { cache: 'no-store' });
    const staticBase = (API_BASE_URL || '').replace(/\/api\/v1$/, '');
    return (res.data.options || []).map((option) => ({
        ...option,
        image: `${staticBase}${option.image}`,
    }));
}
